import { AddressesByPostcode } from '../../graphql.generated';
import { graphql } from 'msw';
import {
    AddressesByPostcodeQuery,
    AddressesByPostcodeQueryVariables
} from '../queries/addressByPostcode.query.generated';

export const generateAddressByPostcodeHandler = (
    addressesByPostcode: Record<string, AddressesByPostcode>
) =>
    graphql.query<AddressesByPostcodeQuery, AddressesByPostcodeQueryVariables>(
        'addressesByPostcode',
        (req, res, ctx) => {
            const { postcode } = req.variables;

            if (postcode === 'THROW ERR') {
                return res(
                    ctx.errors([{ message: 'An expected test error occurred' }])
                );
            }

            const properties = addressesByPostcode[postcode];

            return res(ctx.data({ addressesByPostcode: properties }));
        }
    );

export const VALID_POSTCODE = 'AB10 1AL';
export const PROPERTY_ID_ONE = 32793446;
export const PROPERTY_ID_TWO = 29668975;
export const EMPTY_POSTCODE = 'W1A 1AB'; // Returns an empty array of addreses
export const ERROR_POSTCODE = 'THROW ERR';

export const UPRN_ONE = '9051145706';
export const UPRN_TWO = '10033526433';

const defaultAddressByPostcode: Record<string, AddressesByPostcode> = {
    [VALID_POSTCODE]: {
        __typename: 'AddressesByPostcode',
        addresses: [
            {
                uprn: UPRN_ONE,
                postcode: VALID_POSTCODE,
                fullAddress: '2 Shoe Lane, Aberdeen AB10 1AL',
                __typename: 'Address'
            },
            {
                uprn: UPRN_TWO,
                postcode: VALID_POSTCODE,
                fullAddress: 'Shoe Lane, Aberdeen AB10 1AL',
                __typename: 'Address'
            }
        ]
    },
    [EMPTY_POSTCODE]: {
        __typename: 'AddressesByPostcode',
        addresses: []
    }
};

export const defaultAddressByPostcodeHandler = generateAddressByPostcodeHandler(
    defaultAddressByPostcode
);
